import { HttpErrorResponse } from '@angular/common/http';
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  CustomerInformationResponse,
  PersonalInformation,
  TerminationInformation,
} from '@features/termination/interfaces';
import { Customer, Product, Subscription } from '@features/termination/models';

export enum TerminationActionType {
  CUSTOMER_INFORMATION_LOAD = '[Termination] CustomerInformation Load',
  CUSTOMER_INFORMATION_LOAD_COMPLETE = '[Termination] CustomerInformation Load Complete',
  CUSTOMER_INFORMATION_LOAD_ERROR = '[Termination] CustomerInformation Load Error',

  PRODUCT_LIST_LOAD = '[Termination] ProductList Load',
  PRODUCT_LIST_LOAD_COMPLETE = '[Termination] ProductList Load Complete',
  PRODUCT_LIST_LOAD_ERROR = '[Termination] ProductList Load Error',

  TERMINATION_INFORMATION_SAVE = '[Termination] TerminationInformation Save',

  UPDATE_STEP = '[Termination] Update Step',
  SEND_EMAIL_LOAD = '[Termination] Send Email Load',
  SEND_EMAIL_LOAD_COMPLETE = '[Termination] Send Email Load Complete',
  SEND_EMAIL_LOAD_ERROR = '[Termination] Send Email Load Error',
  UPDATE_PERSONAL_INFORMATION = '[Termination] Update personal information',
}

export const CustomerInformationLoad = createAction(
  TerminationActionType.CUSTOMER_INFORMATION_LOAD,
);

export const CustomerInformationLoadComplete = createAction(
  TerminationActionType.CUSTOMER_INFORMATION_LOAD_COMPLETE,
  props<{ customer: Customer; subscription: Subscription }>(),
);

export const CustomerInformationLoadError = createAction(
  TerminationActionType.CUSTOMER_INFORMATION_LOAD_ERROR,
  props<{ error: HttpErrorResponse | CustomerInformationResponse }>(),
);

export const ProductListLoad = createAction(TerminationActionType.PRODUCT_LIST_LOAD);

export const ProductListLoadComplete = createAction(
  TerminationActionType.PRODUCT_LIST_LOAD_COMPLETE,
  props<{ groundsList: string[]; bank: Product[]; insurances: Product[] }>(),
);

export const ProductListLoadError = createAction(
  TerminationActionType.PRODUCT_LIST_LOAD_ERROR,
  props<{ error: HttpErrorResponse }>(),
);

export const TerminationInformationSave = createAction(
  TerminationActionType.TERMINATION_INFORMATION_SAVE,
  props<{ terminationInformation: TerminationInformation }>(),
);

export const UpdateStep = createAction(
  TerminationActionType.UPDATE_STEP,
  props<{ step: number }>(),
);

export const UpdatePersonalInformation = createAction(
  TerminationActionType.UPDATE_PERSONAL_INFORMATION,
  props<{ personalInformation: PersonalInformation }>(),
);

export const SendEmailLoad = createAction(TerminationActionType.SEND_EMAIL_LOAD);

export const SendEmailLoadComplete = createAction(TerminationActionType.SEND_EMAIL_LOAD_COMPLETE);

export const SendEmailLoadError = createAction(
  TerminationActionType.SEND_EMAIL_LOAD_ERROR,
  props<{ error: HttpErrorResponse | null }>(),
);

export const sendRequestActions = createActionGroup({
  source: 'send Request',
  events: {
    send: emptyProps(),
    'send completed': emptyProps(),
    'send failed': props<{ error: HttpErrorResponse | null }>(),
  },
});
